import React, { useEffect } from "react";
import { Box, Flex } from "theme-ui";
import Header from "components/ui/Header";
import Page from "components/ui/Page";

import PipelineFunnel from "containers/Dashboard/components/PipelineFunnel";
import ExpirationStatsWidget from "containers/Dashboard/components/ExpirationStatsWidget";
import PipelineMetricsWidget from "containers/Dashboard/components/PipelineMetricsWidget";
import OutstandingDepositsWidget from "containers/Dashboard/components/OutstandingDepositsWidget";
import ActivePriceLocksWidget from "containers/Dashboard/components/ActivePriceLocksWidget";
import RecentActivityFeed from "containers/Dashboard/components/RecentActivityFeed";
import ReportsTables from "./ReportsTables";

/**
 * REPORTS - where depth lives (DASHBOARD_REDESIGN_SPEC section 1).
 *
 * Pipeline health, expiration intelligence, deposits, price locks and
 * activity history are analysis: studied, not acted on in ten seconds.
 * They were on the dashboard, which is how the dashboard became the
 * place everything accumulated. Tabs on the dashboard would have
 * repeated that, so they move here and the dashboard links across.
 *
 * NOTHING WAS REBUILT IN THIS MOVE. These are the same components
 * rendered somewhere else, so the numbers are unchanged - including the
 * defects the register already records against some of them (item 22
 * defect 5: the expiration comparisons run against the retroactive
 * backfill and the deltas are meaningless). Moving a wrong number does
 * not fix it. What the move does is stop it sitting beside the numbers
 * that ARE fixed, where the two get read as equally trustworthy.
 *
 * Spec 7.20 is the next thing due here: these queries are heavier than
 * anything on the dashboard, so Reports needs its own performance
 * answer before it grows.
 */
const Reports: React.FC = () => {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_NAME} | Reports`;
  }, []);

  return (
    <>
      <Header />
      <Page
        title="Reports"
        subtitle="Pipeline, expirations and history. The dashboard answers what to do now; this answers how things are trending."
      >
        <Box>
          <PipelineMetricsWidget />

        {/* The two reports spec 3.1 promised: plan profitability and
            provider performance, both period-scoped. */}
        <ReportsTables />
          <ExpirationStatsWidget />

          <Flex
            sx={{
              gap: "16px",
              flexWrap: "wrap",
              marginBottom: "24px",
              alignItems: "stretch",
            }}
          >
            <PipelineFunnel />
          </Flex>

          <OutstandingDepositsWidget />
          <ActivePriceLocksWidget />

          <Flex sx={{ gap: "16px", flexWrap: "wrap", alignItems: "stretch" }}>
            <RecentActivityFeed />
          </Flex>
        </Box>
      </Page>
    </>
  );
};

export default Reports;
